export const WHY = "why";
export const Slider = "slider";
export const Grid = "grid";
export const Hint = "hint";
export const TOPIC_NEWS = "topic_news";
export const RESOURCES = "resources";
export const LOADING = "loading";
